import React from "react";
import styled from "styled-components";
import { colors } from "core/stylesheet";

const Wrap = styled.button`
  background-color: #0077b5;
  &:hover {
    background-color: #004471;
  }
  &:disabled {
    cursor: not-allowed;
    background-color: ${colors.gray};
  }
`;

export default ({ disabled, children, onClick }) => (
  <Wrap
    className="btn input-reset pointer b--none near-white bg-animate inline-flex items-center tc br2 pa2"
    onClick={onClick}
    type="button"
    disabled={disabled}
  >
    <svg
      className="dib h2 w2"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="1.414"
    >
      <path
        d="M13.632 13.635h-2.37V9.922c0-.886-.018-2.025-1.234-2.025-1.235 0-1.424.964-1.424 1.96v3.778h-2.37V6H8.51V7.04h.03c.318-.6 1.092-1.233 2.247-1.233 2.4 0 2.845 1.58 2.845 3.637v4.188zM3.558 4.955c-.762 0-1.376-.617-1.376-1.377 0-.758.614-1.375 1.376-1.375.76 0 1.376.617 1.376 1.375 0 .76-.617 1.377-1.376 1.377zm1.188 8.68H2.37V6h2.376v7.635zM14.816 0H1.18C.528 0 0 .516 0 1.153v13.694C0 15.484.528 16 1.18 16h13.635c.652 0 1.185-.516 1.185-1.153V1.153C16 .516 15.467 0 14.815 0z"
        fillRule="nonzero"
      />
    </svg>
    <span className="f5 ml3 pr2">{children}</span>
  </Wrap>
);



// WEBPACK FOOTER //
// ./src/components/generic/kit/LinkedInButton/index.js